/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FavoritesView,
  getFavoriteVenues,
  toggleFavoriteVenue,
} from '@resy/ui-kitchen';
import { connect } from 'react-redux';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { getUserProfileLocations, postUserProfileLocations } from '../../../../../ui-kitchen/src/api';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

const FavoritesContainer = ({
  Analytics,
  favoriteState,
  favoriteVenues,
  getFavoriteVenues,
  isAuthenticated,
  isMobile,
  selectedDate,
  setQueuedData,
  showAuthModal,
  toggleFavoriteVenue,
  userLocation,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [isMarketable, setIsMarketable] = useState(false);
  const [profileLocations, setProfileLocations] = useState(null);

  const fetchFavoriteVenues = async () => {
    if (!favoriteState.loaded) {
      await getFavoriteVenues({
        lat: userLocation?.lat,
        long: userLocation?.long,
      });
    }
    setLoaded(true);
  };

  const isOptedIn = async () => {
    const profileLocationsData = await getUserProfileLocations();
    setIsMarketable(profileLocationsData?.is_marketable);
    setProfileLocations(profileLocationsData);
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        if (isAuthenticated) {
          await fetchFavoriteVenues();
          await isOptedIn();
        }
      } catch (err) {
        Logger.error('[FavoritesContainer] Error saving favorite venue on mount', err);
      }
    };
    initialize();
  }, [isAuthenticated]);

  const handleFavoriteClick = (response) => {
    const { favorite, venue_id: venueId } = response;

    if (isAuthenticated) {
      try {
        toggleFavoriteVenue({ venueId, favorite });
      } catch (err) {
        Logger.error(err);
      }
    } else {
      setQueuedData(response);
      showAuthModal();
    }
  };

  const toggleIsMarketable = () => {
    postUserProfileLocations({
      locationCodes: profileLocations?.locations,
      isMarketable: !isMarketable,
      primaryLocationCode: profileLocations?.primary,
    });

    setIsMarketable(!isMarketable);
  };

  if (!loaded) {
    return null;
  }

  return (
    <FavoritesView
      toggleIsMarketable={toggleIsMarketable}
      isMarketable={isMarketable}
      restaurants={favoriteVenues.venues}
      favorited={favoriteVenues.venueIds}
      onFavoriteClick={handleFavoriteClick}
      isMobile={isMobile}
      loading={!loaded}
      event={Analytics.event}
      selectedDate={selectedDate}
    />
  );
};

FavoritesContainer.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  favoriteState: PropTypes.shape({
    loaded: PropTypes.bool,
  }).isRequired,
  favoriteVenues: PropTypes.shape({
    loaded: PropTypes.bool,
    venueIds: PropTypes.arrayOf(PropTypes.number),
    venues: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  getFavoriteVenues: PropTypes.func.isRequired,
  toggleFavoriteVenue: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  selectedDate: PropTypes.string,
  setQueuedData: PropTypes.func.isRequired,
  showAuthModal: PropTypes.func.isRequired,
  userLocation: PropTypes.shape({
    lat: PropTypes.number,
    long: PropTypes.number,
  }).isRequired,
};

FavoritesContainer.defaultProps = {
  isMobile: false,
  selectedDate: moment().format('YYYY-MM-DD'),
};

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  userLocation: state.user.userLocation,
  favoriteState: state.favorite,
});

const mapDispatchToProps = {
  getFavoriteVenues,
  toggleFavoriteVenue,
};

FavoritesContainer.displayName = 'FavoritesContainer';
export { FavoritesContainer as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(FavoritesContainer);
